import type { RuleSet } from 'styled-components';

import styled, { css } from 'styled-components';

import { colors } from '~/components/shared/core/styles';
import { Typography } from '~/components/shared/core/typography/Typography';
import { SiteType } from '~/utilities/graphql/codegen';

const GstarSizesTypeStyle = css`
  font-size: ${({ theme }) => theme.font.size[2]};
  font-weight: ${({ theme }) => theme.variables.font.weight.medium};
  color: ${({ theme }) => theme.colors.content.primary};
  text-transform: uppercase;
  margin-bottom: ${({ theme }) => theme.spacing.y.sm};
  line-height: 1.4;
`;
const AafSizesTypeStyle = css`
  font-size: ${({ theme }) => theme.font.size[2]};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.content.primary};
  margin-bottom: ${({ theme }) => theme.spacing.y.md};
  text-transform: uppercase;
  line-height: 1;
`;
const SizesTypeStylesConfig: Record<SiteType, RuleSet> = {
  [SiteType.Gstar]: GstarSizesTypeStyle,
  [SiteType.Wahts]: GstarSizesTypeStyle,
  [SiteType.Outlet]: GstarSizesTypeStyle,
  [SiteType.Employeeshop]: GstarSizesTypeStyle,
  [SiteType.Aaf]: AafSizesTypeStyle,
};

const S = {
  SizeType: styled(Typography)`
    ${({ theme }) => SizesTypeStylesConfig[theme.siteType]}
  `,
};

interface Props {
  label: string;
  testId?: string;
  id?: string;
}

export const SizeBlockType = ({ label, testId, id }: Props) => (
  <S.SizeType
    id={id}
    component="h3"
    variant="h3"
    color={colors.NERO_GREY}
    testId={testId}
    data-cs-capture=""
  >
    {label}
  </S.SizeType>
);
